import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path d="M17.5 12.325c.276 0 .52.167.623.415l.035.112c.3 1.33.693 2.156 1.264 2.726.57.57 1.396.964 2.726 1.264a.675.675 0 0 1 0 1.316l-.475.117c-1.057.284-1.752.648-2.251 1.147-.57.57-.964 1.396-1.264 2.726a.675.675 0 0 1-1.316 0c-.3-1.33-.693-2.155-1.264-2.726-.57-.57-1.396-.964-2.726-1.264a.675.675 0 0 1 0-1.316c1.33-.3 2.156-.693 2.726-1.264.57-.57.964-1.396 1.264-2.726a.675.675 0 0 1 .658-.527M9 1.25a.75.75 0 0 1 .692.462l.04.123c.471 2.094 1.1 3.442 2.045 4.388.887.886 2.127 1.493 4.004 1.955l.384.09a.75.75 0 0 1 0 1.463l-.384.091c-1.877.462-3.117 1.069-4.004 1.955-.945.946-1.574 2.294-2.046 4.388l-.039.123a.75.75 0 0 1-1.423-.123l-.091-.384c-.461-1.877-1.069-3.117-1.955-4.004-.946-.945-2.294-1.574-4.388-2.046a.75.75 0 0 1 0-1.462c2.094-.472 3.442-1.101 4.388-2.046.945-.946 1.574-2.294 2.046-4.388A.75.75 0 0 1 9 1.25" />
  </>
);

const SparkleFilled = Icon('sparkle-filled', svgContents);

export default SparkleFilled;
